import { VelocityVariable } from '../../domain/enrichment/EnrichmentDomain';
import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { VelocityVariableActions } from '../actions/VelocityVariableActions';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { VelocityVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';
import { StreamJsonModel } from '../../domain/stream/stream/StreamDomain';

export interface VelocityVariableState {
  velocityVariable: VelocityVariable;
  permittedTenantStores: Record<string, StreamJsonModel[]>;
  schema: DeploymentModel<VelocityVariableSchema> | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: VelocityVariableState = {
  velocityVariable: ValueFactory.initializeVelocityVariable(),
  schema: { stage: 'DRAFT' } as DeploymentModel<VelocityVariableSchema>,
  permittedTenantStores: {},
  isUpdate: false,
  isDirty: false,
};

export const velocityVariableReducer = (
  state: VelocityVariableState = initialState,
  action: ReduxBaseAction<any, VelocityVariableActions>,
): VelocityVariableState => {
  switch (action.type) {
    case 'CHANGE_VELOCITY_VARIABLE':
      return { ...state, velocityVariable: action.payload, isDirty: true };
    case 'CHANGE_VELOCITY_VARIABLE_SCHEMA':
      return { ...state, schema: action.payload };
    case 'CHANGE_VELOCITY_VARIABLE_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_VELOCITY_VARIABLE':
      return { ...state, velocityVariable: ValueFactory.initializeVelocityVariable(), isUpdate: false, schema: null, isDirty: false };
    case 'CHANGE_VELOCITY_VARIABLE_DIRTY':
      return { ...state, isDirty: action.payload };
    case 'CHANGE_VELOCITY_VARIABLE_PERMITTED_STORES':
      return { ...state, permittedTenantStores: action.payload };
    default:
      return state;
  }
};
